/* Capelli — herramientas del cart drawer (réplica capellisport.com):
   fila "Nota del pedido | Calcular envío" con paneles colapsables.
   - Nota: textarea que guarda en cart.note vía /cart/update.js (debounced).
   - Envío: región de Chile → /cart/shipping_rates.json; fallback "se calcula en el checkout".
   Event delegation en document para sobrevivir el re-render del drawer (Section Rendering API). */
(function () {
  'use strict';
  var noteTimer = null;

  function up(el, sel) { return el && el.closest ? el.closest(sel) : null; }

  function money(cents) {
    try { return (cents / 100).toLocaleString('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }); }
    catch (e) { return '$' + Math.round(cents / 100); }
  }

  document.addEventListener('click', function (e) {
    var calc = up(e.target, '.cap-ship-calc');
    if (calc) { e.preventDefault(); estimate(calc); return; }

    var btn = up(e.target, '.cap-tool-btn');
    if (!btn) return;
    e.preventDefault();
    var tools = up(btn, '.cap-cart-tools');
    if (!tools) return;
    var which = btn.getAttribute('data-tool');
    var panel = tools.querySelector('.cap-tool-panel[data-panel="' + which + '"]');
    var willOpen = panel ? panel.hidden : false;
    tools.querySelectorAll('.cap-tool-panel').forEach(function (p) { p.hidden = true; });
    tools.querySelectorAll('.cap-tool-btn').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (panel && willOpen) {
      panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      var f = panel.querySelector('textarea, select');
      if (f) { try { f.focus(); } catch (_) {} }
    }
  });

  document.addEventListener('input', function (e) {
    var ta = up(e.target, '.cap-note-input');
    if (!ta) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: ta.value })
      }).catch(function () {});
    }, 600);
  });

  function estimate(btn) {
    var tools = up(btn, '.cap-cart-tools');
    if (!tools) return;
    var sel = tools.querySelector('.cap-ship-region');
    var out = tools.querySelector('.cap-ship-result');
    if (!out) return;
    var region = sel ? sel.value : '';
    if (!region) { out.textContent = 'Selecciona tu región.'; return; }
    out.textContent = 'Calculando…';
    var url = '/cart/shipping_rates.json'
      + '?shipping_address%5Bcountry%5D=Chile'
      + '&shipping_address%5Bprovince%5D=' + encodeURIComponent(region)
      + '&shipping_address%5Bzip%5D=';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var rates = (data && data.shipping_rates) || [];
        if (!rates.length) { out.innerHTML = 'El envío se calcula en el checkout.'; return; }
        var html = '<ul class="cap-ship-list">';
        rates.forEach(function (rt) {
          var p = parseFloat(rt.price);
          var label = (isFinite(p) && p === 0) ? 'Gratis' : money(p * 100);
          html += '<li><span>' + rt.name + '</span><span>' + label + '</span></li>';
        });
        html += '</ul>';
        out.innerHTML = html;
      })
      .catch(function () { out.innerHTML = 'El envío se calcula en el checkout.'; });
  }
})();

/* Capelli — auto-abrir el drawer al añadir al carro (réplica capellisport.com). El setting del theme
   auto_open_cart_drawer está en false; se fuerza el atributo auto-open en <cart-drawer-component>,
   que el componente nativo usa para abrir el drawer en cada cart update. El MutationObserver lo
   re-aplica si el Section Rendering API recrea el componente tras un add/update. */
(function () {
  'use strict';
  function ensure() {
    document.querySelectorAll('cart-drawer-component:not([auto-open])').forEach(function (c) {
      c.setAttribute('auto-open', '');
    });
    // Desactivar el efecto "fly to cart" por defecto de Horizon (la imagen del producto que vuela
    // al ícono del carrito): el drawer ya se auto-abre, ese efecto sobra. El componente lo gatea con
    // data-add-to-cart-animation; en "false" no crea el elemento .fly-to-cart.
    document.querySelectorAll('add-to-cart-component[data-add-to-cart-animation="true"]').forEach(function (c) {
      c.setAttribute('data-add-to-cart-animation', 'false');
    });
  }
  ensure();
  document.addEventListener('DOMContentLoaded', ensure);
  try {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { ensure(); break; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  // Cierre robusto del drawer: intenta el método del componente (animado) y, si sigue abierto,
  // fuerza quitar [open] (un <dialog> sin [open] es display:none por UA; el overlay :has() se limpia).
  function capCloseCart() {
    var dlg = document.querySelector('#cart-drawer .theme-drawer__dialog[open]');
    if (!dlg) return;
    var td = document.getElementById('cart-drawer');
    try { if (td && typeof td.close === 'function') td.close(); } catch (_) {}
    setTimeout(function () {
      var d = document.querySelector('#cart-drawer .theme-drawer__dialog[open]');
      if (d) { try { d.removeAttribute('open'); if (d.open) d.open = false; } catch (_) {} }
    }, 350);
  }

  // Cerrar al click en el área difuminada (backdrop = body::after con pointer-events:auto → el click
  // se atribuye a <body>, fuera de #cart-drawer). Se ignora el click dentro del drawer y el del toggle.
  document.addEventListener('click', function (e) {
    if (!document.querySelector('#cart-drawer .theme-drawer__dialog[open]')) return;
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('#cart-drawer') || e.target.closest('[on\\:click*="cart-drawer"]')) return;
    capCloseCart();
  });

  // Cerrar al clickear un tile de "Compra por deporte": Horizon hace nav suave y preserva el drawer
  // (data-skip-node-update), dejándolo abierto sobre la colección destino.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('#cart-drawer .cap-cart-sports__tile')) capCloseCart();
  });
})();
